import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  clearBirthState,
  clearOptimisticBirthDateTime,
  selectBirthDateTime,
  setOptimisticBirthDateTime,
} from "@/store/slices/birth";

export function useBirthObservations(encounterId?: string, clientId?: string) {
  const dispatch = useDispatch();
  const birthDateTime = useSelector(selectBirthDateTime);

  // Function to set optimistic birth state (when user fills out a form)
  const setOptimisticBirth = useCallback(
    (birthDateTime: string) => {
      dispatch(setOptimisticBirthDateTime(birthDateTime));
    },
    [dispatch],
  );

  // Function to clear birth state (when switching encounters)
  const clearBirthData = useCallback(() => {
    dispatch(clearBirthState());
  }, [dispatch]);

  const clearOptimisticBirth = useCallback(() => {
    dispatch(clearOptimisticBirthDateTime());
  }, [dispatch]);

  return {
    birthDateTime,
    setOptimisticBirth,
    clearOptimisticBirth,
    clearBirthData,
  };
}
